"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetDataSalesforcePayloadSchema = void 0;
exports.GetDataSalesforcePayloadSchema = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    properties: {
        sonosId: {
            type: 'string',
            minLength: 1,
        },
        subscriptionRatePlanId: {
            type: 'string',
            minLength: 1,
        },
        currency: {
            type: 'string',
            minLength: 1,
        },
        messageId: {
            type: 'string',
            minLength: 1
        }
    },
    required: [
        'sonosId',
        'subscriptionRatePlanId',
        'currency',
        'messageId'
    ],
    type: 'object',
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0LWRhdGEtc2FsZXNmb3JjZS1zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvZG9tcy9zY2hlbWFzL3p1b3JhL2dldC1kYXRhLXNhbGVzZm9yY2Utc2NoZW1hLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFhLFFBQUEsOEJBQThCLEdBQUc7SUFDNUMsT0FBTyxFQUFFLHlDQUF5QztJQUNsRCxVQUFVLEVBQUU7UUFDVixPQUFPLEVBQUU7WUFDUCxJQUFJLEVBQUUsUUFBUTtZQUNkLFNBQVMsRUFBRSxDQUFDO1NBQ2I7UUFDRCxzQkFBc0IsRUFBRTtZQUN0QixJQUFJLEVBQUUsUUFBUTtZQUNkLFNBQVMsRUFBRSxDQUFDO1NBQ2I7UUFDRCxRQUFRLEVBQUU7WUFDUixJQUFJLEVBQUUsUUFBUTtZQUNkLFNBQVMsRUFBRSxDQUFDO1NBQ2I7UUFDRCxTQUFTLEVBQUU7WUFDVCxJQUFJLEVBQUUsUUFBUTtZQUNkLFNBQVMsRUFBRSxDQUFDO1NBQ2I7S0FDRjtJQUNELFFBQVEsRUFBRTtRQUNSLFNBQVM7UUFDVCx3QkFBd0I7UUFDeEIsVUFBVTtRQUNWLFdBQVc7S0FDWjtJQUNELElBQUksRUFBRSxRQUFRO0NBQ2YsQ0FBQSIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBjb25zdCBHZXREYXRhU2FsZXNmb3JjZVBheWxvYWRTY2hlbWEgPSB7XG4gICRzY2hlbWE6ICdodHRwOi8vanNvbi1zY2hlbWEub3JnL2RyYWZ0LTA3L3NjaGVtYSMnLFxuICBwcm9wZXJ0aWVzOiB7XG4gICAgc29ub3NJZDoge1xuICAgICAgdHlwZTogJ3N0cmluZycsXG4gICAgICBtaW5MZW5ndGg6IDEsXG4gICAgfSxcbiAgICBzdWJzY3JpcHRpb25SYXRlUGxhbklkOiB7XG4gICAgICB0eXBlOiAnc3RyaW5nJyxcbiAgICAgIG1pbkxlbmd0aDogMSxcbiAgICB9LFxuICAgIGN1cnJlbmN5OiB7XG4gICAgICB0eXBlOiAnc3RyaW5nJyxcbiAgICAgIG1pbkxlbmd0aDogMSxcbiAgICB9LFxuICAgIG1lc3NhZ2VJZDoge1xuICAgICAgdHlwZTogJ3N0cmluZycsXG4gICAgICBtaW5MZW5ndGg6IDFcbiAgICB9XG4gIH0sXG4gIHJlcXVpcmVkOiBbXG4gICAgJ3Nvbm9zSWQnLFxuICAgICdzdWJzY3JpcHRpb25SYXRlUGxhbklkJyxcbiAgICAnY3VycmVuY3knLFxuICAgICdtZXNzYWdlSWQnXG4gIF0sXG4gIHR5cGU6ICdvYmplY3QnLFxufVxuXG4iXX0=